import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ILogic} from '@gongxigames/framework/slot/types';
import {DI} from '@gongxigames/framework/slot';
import {CoreDI, inject, inversifyContainer} from '@gongxigames/framework/core';
import {DefaultEventsMap, IEventManagerWithAsync} from '@gongxigames/framework/core/types';
import {KeypadControlsEvents} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsEvents';
import {FlowModuleEvents} from '@gongxigames/framework/slot';
import {betControlStore} from './BetControlStore';

// TODO: Make it the same file for slotV1 and slotV2
export class BetControlService extends UiServiceV2 {
    public static NAME = 'BetControlService';

    private _logic!: ILogic;

    /**
     * // TODO: refactor
     * @deprecated
     */
    @inject(CoreDI.IEventManagerWithAsync)
    private _eventManager!: IEventManagerWithAsync<DefaultEventsMap>;

    protected _currentBetValue = betControlStore.slot_bet;
    protected _currentBetFormatted = betControlStore.slot_betFormatted;
    protected _possibleBetValues = betControlStore.slot_betList;

    onSetupEvents(): void {
        this.emitter.on('UI.bet.increase', this.onChangeBet.bind(this, true));
        this.emitter.on('UI.bet.decrease', this.onChangeBet.bind(this, false));
        this.emitter.on('UI.bet.setByIndex', this.setByIndex.bind(this));

        this.abortSignal.addEventListener('abort', () => this._eventManager.offAllFromOwner(this));

        this._eventManager.on('General.Game.INITIALIZED', this.setupBetFormatter.bind(this), this);
        this._eventManager.on('General.Game.INITIALIZED', this.onGameInitialized.bind(this), this);
        this._eventManager.on(KeypadControlsEvents.UPDATE_KEYPAD, this.onGameInitialized.bind(this), this);
        this._eventManager.on(FlowModuleEvents.ENTER_BASIC_STATE, this.onEnterFlowBasicState.bind(this), this);
    }

    protected onChangeBet(increase: boolean): void {
        const bets = this._possibleBetValues.value;
        let index = bets.indexOf(this._currentBetValue.value);

        index += increase ? 1 : -1;

        this.setByIndex(index);
    }

    protected setByIndex(index: number): void {
        const bets = this._possibleBetValues.value;

        if (index >= 0 && index < bets.length) {
            this._currentBetValue.value = bets[index];
        }

        this.emitTotalBetChanged();
    }

    private emitTotalBetChanged(): void {
        const index = this.getBetIndex();

        this.logic.betId = index;
        this.logic.updateSessionBet();
        slotStore.reComputeLogicTrigger.value++;

        this.emitter.emit('UI.command.totalBetChanged');
        this._eventManager.emit(KeypadControlsEvents.TOTAL_BET_CHANGED, index, this._currentBetFormatted.value);
        this._eventManager.emit('General.UI.BET.CHANGED', this._logic.getBetInfo());
    }

    protected onGameInitialized(): void {
        slotStore.reComputeLogicTrigger.value++;
        const {logic_nextActionIsSpin, logic_sessionBet, logic_defaultBet, logic_bets} = slotStore.values();
        const initialBet = !logic_nextActionIsSpin ? logic_sessionBet : logic_defaultBet;

        this._possibleBetValues.value = logic_bets;
        this._currentBetValue.value = initialBet;
        this.emitTotalBetChanged();
    }

    private onEnterFlowBasicState(): void {
        const bet = this._currentBetValue.value;
        const isCurrentBetStillExists = this._possibleBetValues.value.includes(bet);

        if (isCurrentBetStillExists) {
            return;
        }
        const defaultBet = slotStore.logic_defaultBet.value;
        let index = this._possibleBetValues.value.indexOf(defaultBet);

        if (index === -1) {
            index = 0;
        }

        this._currentBetValue.value = this._possibleBetValues.value[index];

        this.emitTotalBetChanged();
    }

    private getBetIndex(): number {
        const bet = this._currentBetValue.value;

        return this._possibleBetValues.value.indexOf(bet);
    }

    private setupBetFormatter() {
        const off = Store.effect(() => {
            const currencyFormatter = slotStore.currencyFormatter.value;

            if (!currencyFormatter) {
                return;
            }

            const bet = this._currentBetValue.value;
            const str = currencyFormatter.formatCents(bet * slotStore.logic_wager.value);

            this._currentBetFormatted.value = str;
        });

        this.abortSignal.addEventListener('abort', off);
    }

    get logic(): ILogic {
        return this._logic ??= inversifyContainer.get<ILogic>(DI.Logic);
    }
}